export default {
  notPossible: 'Ruch ręczny nie jest możliwy',
  executedConfirm: 'Czy ruch z "{source}" do "{target}" jest wykonywany?',
  command: {
    accept: 'Zaakceptuj polecenie',
    ack: 'Zatwierdź',
  },
};
